import { useContext } from "react";
import { TimersContext } from "../contexts/index.js";

export default function useTimers() {
  return useContext(TimersContext);
}
